import { createContext, useContext } from 'react';
import { SegmentationId } from '@/generated/data.schemas';

interface SegmentationContextProps {
	segmentationId: SegmentationId;
	url: string;
}

export const SegmentationContext = createContext<SegmentationContextProps>({
	segmentationId: 1,
	url: '',
});

export const useSegmentation = (): SegmentationContextProps => useContext(SegmentationContext);
